<template>
  <div id="app" class="overflow-x-hidden" :class="{ 'dark-mode': isDarkMode }">
    <!-- Loader Start -->
    <div id="loader" class="loader">
      <div id="loaderContent" class="loader__content">
        <div class="loader__shadow"></div>
        <div class="loader__box"></div>
      </div>
    </div>
    <!-- Loader End -->

    <Header
      :menu-items="menuItems"
      :logo="'/home.png'"
      @color-switch="toggleColorScheme"
    />
    <Avatar :socials="socials" />

    <div id="content" class="content overflow-x-hidden">
      <main class="content__wrapper max-w-full overflow-x-hidden">
        <About />
        <Tools />
        <Skill />
        <Resume :experience="experience" :tools="tools" />
        <Education :educationItems="educationItems" />
        <Contact />
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useHead } from '@vueuse/head'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Head / Meta
useHead({
  title: 'Farras Naufal - Portfolio Website',
  meta: [
    {
      name: 'description',
      content: 'Portfolio Farras Naufal, Quality Assurance Engineer.'
    },
    {
      property: 'og:title',
      content: 'Farras Naufal Portfolio'
    },
    {
      property: 'og:description',
      content: 'Explore QA projects and tools by Farras Naufal.'
    }
  ],
 link: [
  { rel: 'icon', type: 'image/svg+xml', href: '/FarrasLogo.svg', sizes: '64x64' }
]

})

// Komponen
import Header from './components/Header.vue'
import Avatar from './components/Avatar.vue'
import About from './components/About.vue'
import Tools from './components/Tools.vue'
import Skill from './components/Skill.vue'
import Resume from './components/Experience.vue'
import Education from './components/Education.vue'
import Contact from './components/Contact.vue'

// Data
const isDarkMode = ref(false)

const toggleColorScheme = () => {
  isDarkMode.value = !isDarkMode.value
  document.documentElement.setAttribute('color-scheme', isDarkMode.value ? 'dark' : 'light')
}

const educationItems = [
  {
    title: 'Cyber Security Professional Academy',
    year: 'September 2024',
    place: 'Digital Talent Scholarship',
    // description: 'Understand the importance of cybersecurity practices and their impact for organizations.',
  },
  {
    title: 'Google Cybersecurity Specialization',
    year: 'September 2024',
    place: 'Google',
    // description: '',
  },
  {
    title: 'Software Quality Assurance Intensive Bootcamp',
    year: 'December 2022',
    place: 'SanberCode',
  },
  {
    title: 'AWS Cloud Operations Professional Academy',
    year: 'October 2022',
    place: 'Digital Talent Scholarship',
    // description: ''
  },
  {
    title: 'AWS Academy Cloud Operations',
    year: 'October 2022',
    place: 'Amazon Web Services',
    // description: ''
  },
  {
  title: 'Completion of UI UX Design Professional Academy',
  year: 'July 2022',
  place: 'Digital Talent Scholarship',
  // description: ''
  },
  {
    title: 'UI/UX Design Mastery (Gold)',
    year: 'May 2022',
    place: 'Skilvul & Badgr',
    // description: ''
  }
]

const experience = [] // isi sesuai kebutuhan
const tools = [] // isi sesuai kebutuhan
const socials = [] // isi sesuai kebutuhan

 menuItems: [
  // { id: 'avatar', label: 'Home', icon: 'fa-solid fa-house' },
  { id: 'about', label: 'About Me', icon: 'fa-solid fa-user' },
  { id: 'tools', label: 'Tools', icon: 'fa-solid fa-wrench' }, // beda dari Skill
  { id: 'skill', label: 'Skills', icon: 'fa-solid fa-lightbulb' },
  { id: 'experience', label: 'Experience', icon: 'fa-solid fa-briefcase' },
  { id: 'education', label: 'Education', icon: 'fa-solid fa-certificate' },
  { id: 'contact', label: 'Contact', icon: 'fa-solid fa-envelope' }
]
// Animasi
const initAnimations = () => {
  gsap.registerPlugin(ScrollTrigger)
  gsap.utils.toArray('.animate-in-up').forEach(el => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top bottom-=100'
      },
      y: 50,
      opacity: 0,
      duration: 1
    })
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)

  // Loader animasi
  gsap.to('#loader', {
    duration: 0.5,
    autoAlpha: 0,
    delay: 1.5,
    ease: 'power2.out'
  })

  initAnimations()
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

const handleScroll = () => {
  // tambahkan logika scroll section jika dibutuhkan
}
</script>

<style>
html,
body {
  overflow-x: hidden;
  max-width: 100%;
}

@import './assets/main.css';
</style>
